import React, { useContext, useEffect, useState } from 'react';
import { PriceRowContextContainer } from '../price-row-context';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { insertTableAds } from '../ads';
import { PriceRow } from '../price-row/row-types';
import { createOfferFromPriceItem } from '../utils';
import {
  useMobileTopAdExperiment,
  useOurChoiceExperiment,
} from 'src/hooks/experiments';
import { IPriceListBodyProps } from './types';
import { PriceListContext } from '../context';
import { OurChoiceWrapper } from '../price-row/row-types/our-choice';
import { PriceList } from './styles';

const PriceListBody: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceListBodyProps>
>> = props => {
  const {
    sortedPrices,
    showMorePrices,
    numberOfVisiblePrices,
    productName,
    productId,
    media,
    brand,
    priceDisplay,
    campaign,
  } = props;
  const experiment = useMobileTopAdExperiment();
  const { filters } = useContext(PriceListFilterContext);
  const { ourChoice } = useContext(PriceListContext);
  const [
    ourChoiceExperimentIsEnabled,
    setOurChoiceExperimentIsEnabled,
  ] = useState(false);
  const ourChoiceExperiment = useOurChoiceExperiment();

  useEffect(() => {
    setOurChoiceExperimentIsEnabled(ourChoiceExperiment);
  }, [ourChoiceExperiment]);

  return (
    <PriceList>
      {sortedPrices &&
        sortedPrices.length > 0 &&
        insertTableAds(
          sortedPrices
            .slice(0, showMorePrices ? undefined : numberOfVisiblePrices)
            .map((item, index) => {
              const rowKey = `${item.id}-${index}`;
              const offer = createOfferFromPriceItem(item, filters);
              const RowComponent = <PriceRow item={item} index={index} />;
              const isOurChoice = ourChoice?.id === item.id;
              return (
                <PriceRowContextContainer
                  key={rowKey}
                  productId={productId}
                  productName={productName}
                  productImage={media?.first}
                  brand={brand}
                  priceDisplay={priceDisplay}
                  campaign={campaign}
                  showExpandButton
                  offer={offer}
                  position="offerList"
                  isOurChoice={isOurChoice}
                >
                  {ourChoiceExperimentIsEnabled && isOurChoice ? (
                    <OurChoiceWrapper>{RowComponent}</OurChoiceWrapper>
                  ) : (
                    RowComponent
                  )}
                </PriceRowContextContainer>
              );
            }),
          experiment === 'no top ad + lift ad in price list'
        ).map(row => <li key={row.key}>{row}</li>)}
    </PriceList>
  );
};

export default PriceListBody;
